// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_dialog.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for showing and hiding Bootstrap modals, including 
//     management of modal stacking to handle multiple open modals.
// </summary>
// ***********************************************************************

window.dialog = window.dialog || {};
window.dialog.modalStack = 0;

/**
 * Displays a Bootstrap modal dialog with the specified ID.
 * This function initializes the modal with a static backdrop and disables keyboard interactions
 * to prevent accidental closing. It also manages the modal stack to correctly handle multiple modals.
 * 
 * @function showModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to display.
 */
window.dialog.showModal = function (id, backdropType = 'static') {
    var modalElement = document.getElementById(id);
    var myModal = new window.bootstrap.Modal(modalElement, {
        backdrop: backdropType,
        keyboard: false
    });
    myModal.show();
    window.dialog.modalStack++;

    modalElement.addEventListener('hidden.bs.modal', function () {
        window.dialog.modalStack--;
        if (window.dialog.modalStack === 0) {
            var backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
                backdrop.remove();
            }
        }
        modalElement.dataset.listenerAdded = true;
    });
};

/**
 * Displays a Bootstrap modal dialog with the specified ID.
 * This function initializes the modal with the option to disable the backdrop and enables
 * keyboard interactions, allowing the modal to be closed with the ESC key.
 * It also manages the modal stack to correctly handle multiple modals.
 *
 * @function showNavbarSearchModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to display.
 */
window.dialog.showNavbarSearchModal = function (id) {
    var modalElement = document.getElementById(id);
    var searchDialog = new window.bootstrap.Modal(modalElement, {
        backdrop: true,
        keyboard: true
    });

    document.removeEventListener('keydown', escKeyListener);
    document.removeEventListener('click', backdropClickListener);

    searchDialog.show();
    window.dialog.modalStack++;

    var escKeyListener = function (event) {
        if (event.key === 'Escape') {
            searchDialog.hide(); 
        }
    };
    
    var backdropClickListener = function (event) {
        if (!modalElement.contains(event.target)) {
            searchDialog.hide(); 
        }
    };

    modalElement.addEventListener('hidden.bs.modal', function () {
        window.dialog.modalStack--;
        if (window.dialog.modalStack === 0) {
            var backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
                backdrop.remove();
            }
        }

        document.addEventListener('keydown', escKeyListener);
        document.addEventListener('click', backdropClickListener);
    });
};

/**
 * Displays a Bootstrap modal dialog with the specified ID.
 * This function initializes the modal with a static backdrop and disables keyboard interactions
 * to prevent accidental closing. It also manages the modal stack to correctly handle multiple modals.
 *
 * @function showModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to display.
 */
window.dialog.showModalNoBackdrop = function (id) {
    var modalElement = document.getElementById(id);
    var myModal = new window.bootstrap.Modal(modalElement, {
        backdrop: false,
        keyboard: false
    });

    myModal.show();
};

/**
 * Hides a Bootstrap modal dialog with the specified ID.
 * This function hides the modal and ensures that it is properly removed from the view.
 * 
 * @function hideModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to hide.
 */
window.dialog.hideModal = function (id) {
    var modalElement = document.getElementById(id);
    var myModal = new window.bootstrap.Modal(modalElement);
    myModal.hide();
};